import { funcScrollControl,} from './index';

const modal = (() => {

  const pageEquipment = (document.getElementById("pageEquipment") != null);
  if (pageEquipment) {

    const body = document.querySelector('body');
    const btnOpen = document.querySelector('.js-btnModal');
    const btnClose = document.querySelector('.js-btnClose');
    const modalWrap = document.querySelector('.modal-wrap');
    let video = document.querySelector('.js-video');

    btnOpen.addEventListener('click', () => {
      modalWrap.classList.add("show");
      funcScrollControl.noScroll();
      video.play();
    });

    btnClose.addEventListener('click', () =>{
      modalWrap.classList.remove("show");
      funcScrollControl.returnScroll();
      video.pause();
    });

    video.addEventListener('click', (event) => {//動画をクリックできないようにする
      event.preventDefault();
      event.stopPropagation();
    });

    
    modalWrap.addEventListener('click', () =>{
      const checkBody = body.classList.contains('pc');
        if (!checkBody) {//クラスPCなしのとき
        } else {
          modalWrap.classList.remove("show");
          funcScrollControl.returnScroll();
          video.pause();
        }
    });

  }

})();
export default modal;